/* eslint-disable max-lines */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable max-lines-per-function */
/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useRef, useState } from "react";
import ReactGA from "react-ga4";
import { Button, Checkbox, Col, Form, Input, Row, Space, Typography } from "antd";
import { ROUTES_PATH } from "routes/Routes.Constant";
import { useNavigate } from "react-router";
import { BlobProviderParams, BlobProvider, PDFDownloadLink } from "@react-pdf/renderer";
import { useSearchParams } from "react-router-dom";
import { getConfigurationDetails, getImage, sendEmail } from "api/services/shareDesign.api";
import { AxiosError } from "axios";
import { useAppSelector } from "hooks/reduxHooks";
import { setPlayerRoster } from "store/slices/playerRoster.slice";
import { useDispatch } from "react-redux";
import { RuleObject } from "antd/es/form";
import { associateProduct, getProductsByDesignId } from "api/services/product.api";
import { notificationController } from "components/Common/Notification/Notification";
import { getUserData } from "utils";
import PdfViewer, { MobilePdf } from "./Pdf/PdfViewer";
import Pdf from "./Pdf/Pdf";
import "./ShareDesign.scss";
import { ProductListItem, SelectedCustomProducts } from "interfaces/ApiInterface/IProductGroupList";
import { ArrayOfArrays } from "interfaces/ShareDesign/IShareDesign";

const { Text } = Typography;

const ShareDesign2 = () => {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const pdfIframeRef = useRef(null);
  const user = JSON.parse(localStorage.getItem("UserRecord") || "");
  const [searchParams] = useSearchParams();
  const playerRoster = useAppSelector((state: any) => state?.playerRoster?.initialState);
  const lockerDetails = useAppSelector((state: any) => state.landingPage.lockerPortalDetails);
  const [isEmailSending, setIsEmailSending] = useState<boolean>(false);
  const [productImages, setProductImages] = useState<any>([]);
  const [productDetails, setProductDetails] = useState<any>(null);
  const [productListForEmailTemplate, setProductListForEmailTemplate] = useState<any>([]);
  const [productListForEmailTemplateCopy, setProductListForEmailTemplateCopy] = useState<any>([]);
  const [associatedProductsList, setAssociatedProductsList] = useState<any>({});
  const [pdfFile, setPdfFile] = useState<Blob | null>(null);
  const [imgUrl, setImgUrl] = useState<ArrayOfArrays>([]);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 770);
  const [loader, setLoader] = useState<boolean>(true);
  const userId: number = JSON.parse(localStorage.getItem("UserRecord") || "")?.UserId;

  const handleResize = () => {
    setIsMobile(window.innerWidth < 770);
  };

  useEffect(() => {
    window.addEventListener("resize", handleResize);

    if (loader)
      setTimeout(() => {
        setLoader(false);
      }, 5000);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    if (isMobile) {
      const fetchData = async () => {
        const arr = JSON.parse(JSON.stringify([...productImages]));

        if (productImages.length > 0) {
          const promises = productImages.map((productImage: any, index1: number) => {
            if (!productImage[0].img.includes("artifi"))
              return Promise.all(
                productImage.map(async (imgData: any, index2: number) => {
                  const res = await getImage(imgData.img);
                  arr[index1][index2] = res.data;
                })
              );
          });

          await Promise.all(promises);
          setImgUrl([...arr]);
        }
      };

      fetchData();
    }
  }, [productImages, isMobile]);

  const selectedProducts: SelectedCustomProducts[] = JSON.parse(
    localStorage.getItem("selectedItemsToShare") || ""
  );

  const getCode = (code: string): string[] => {
    if (code === "Helmet") {
      return ["helmets", "rawlings"];
    }
    if (code === "RawlingsGlove") {
      return ["gloves", "rawlings"];
    }
    if (code === "EastonGlove") {
      return ["gloves", "easton"];
    }
    if (code === "WoodBat") {
      return ["woodbats", "rawlings"];
    }
    return [];
  };

  const openConfigurationWindow = ([product, domain]: string[], designId: string): string => {
    const configUrl = process.env.REACT_APP_THIRD_PARTY_CONFIGURATION;
    const openConfig = configUrl?.replace("<product>", product).replace("<domain>", domain);
    return `${openConfig}/review/${designId}`;
  };

  useEffect(() => {
    if (lockerDetails && productListForEmailTemplate?.length > 0) {
      associateProduct(
        lockerDetails?.lockerPortalDetails?.PortalId,
        lockerDetails?.lockerPortalDetails?.PublishCatalogId
      )
        .then((res: any) => {
          setAssociatedProductsList(res);
        })
        .catch((error) => {
          throw error;
        });
    }
  }, [productListForEmailTemplate, lockerDetails]);

  useEffect(() => {
    productListForEmailTemplate?.map((productList: ProductListItem, index: number) => {
      if (productList?.DesignType === "Rawlings") {
        if (
          associatedProductsList &&
          associatedProductsList?.data &&
          associatedProductsList?.data?.PublishProducts
        ) {
          let url = "";
          const isProduct = associatedProductsList?.data?.PublishProducts?.find(
            (item: any) => item.SKU === productList?.SKU
          );

          const configurationTypeObject = isProduct?.Attributes?.find(
            (attribute: { AttributeCode: string }) =>
              attribute.AttributeCode === "ConfigurationType"
          );

          const helmet = configurationTypeObject?.SelectValues?.find(
            (value: { Code: string }) => value.Code === "Helmet"
          );

          const rawlingsGlove = configurationTypeObject?.SelectValues?.find(
            (value: { Code: string }) => value.Code === "RawlingsGlove"
          );

          const eastonGlove = configurationTypeObject?.SelectValues?.find(
            (value: { Code: string }) => value.Code === "EastonGlove"
          );

          const woodBat = configurationTypeObject?.SelectValues?.find(
            (value: { Code: string }) => value.Code === "WoodBat"
          );

          if (helmet)
            url = openConfigurationWindow(getCode(helmet?.Code), productList?.ConfigurationId);
          if (rawlingsGlove)
            url = openConfigurationWindow(
              getCode(rawlingsGlove?.Code),
              productList?.ConfigurationId
            );
          if (eastonGlove)
            url = openConfigurationWindow(getCode(eastonGlove?.Code), productList?.ConfigurationId);
          if (woodBat)
            url = openConfigurationWindow(getCode(woodBat?.Code), productList?.ConfigurationId);
          const productListCopy = [...productListForEmailTemplate];
          productListCopy[index]["PreviewUrl"] = url;
          setProductListForEmailTemplateCopy([...productListCopy]);
        }
      } else {
        const productListCopy = [...productListForEmailTemplate];
        productListCopy[index]["PreviewUrl"] = null;
        setProductListForEmailTemplateCopy([...productListCopy]);
      }
    });
  }, [associatedProductsList]);

  const onSubmitEmail = async (values: any) => {
    const userData = getUserData();
    setIsEmailSending(true);
    const formData: any = new FormData();
    const data = {
      Products: productListForEmailTemplateCopy,
      SendToEmailAddress: values.emails.replace(" ", ""),
      CCEmailAddress: values?.myEmail ? user?.Email : "",
      PortalId: lockerDetails?.lockerPortalDetails?.PortalId,
      LocaleId: 1,
      UserId: userData?.UserId,
    };

    formData.append("emailData", JSON.stringify(data));
    formData.append("attachment", pdfFile);

    ReactGA.event({
      category: "send_product_detail_email",
      action: "send product details email button clicked",
      label: "send product details email button clicked"
    });
    sendEmail(formData)
      .then((result: any) => {
        if (result?.status === 200 && result?.data?.IsSuccess) {
          notificationController.success({
            message: "Email sent successfully.",
          });

          navigate(ROUTES_PATH.HOMEPAGE);
        }
      })
      .catch((error: any) => {
        setIsEmailSending(false);
        throw error;
      });
  };

  const getProductFourImagesOnOnePage = (data: any) => {
    if (data) {
      const result: any = [];
      data.forEach((item: any) => {
        const images = item.img;
        for (let i = 0; i < images.length; i += 2) {
          const imgList = images.slice(i, i + 2);
          const data = [];
          if (imgList.length === 2) {
            data.push({
              designId: item.designId,
              configurationName: item.configurationName,
              img: imgList[0],
            });
            data.push({
              designId: item.designId,
              configurationName: item.configurationName,
              img: imgList[1],
            });
          } else {
            data.push({
              designId: item.designId,
              configurationName: item.configurationName,
              img: imgList[0],
            });
          }
          result.push(data);
        }
      });
      return result;
    }
    return [];
  };

  const getProductDetailsInStructuredManner = (data: any) =>
    data.map((item: any) => {
      const designData = item.designData.map((designItem: any) => ({
        viewName: designItem.viewName,
        layoutLocationName: designItem.layoutLocationName,
        images: designItem.image,
        text: designItem.text,
      }));

      const customAttributes = item.customAttributes.map((customAttribute: any) => ({
        displayName: customAttribute.displayName,
        value: customAttribute.value,
        color: customAttribute.selectedValue.value,
        gradientColors: customAttribute.selectedValue?.childAttributeValues?.map((attribute: any) => attribute.value)
      }));

      return {
        productName: item.productName,
        pickStyle: item.pickedStyle,
        selectFabric: item.selectedFabric,
        selectDesignTemplate: item.selectedDesignTemplate,
        sku: item.sku,
        designId: item.designId,
        designName: item.designName,
        designType: item.designType,
        designData: designData,
        customAttributes: customAttributes,
        configurationName: item.configurationName,
      };
    });

  const getProductDataForEmailTable = (data: any): void => {
    const emailProductList = [];
    const znodeMyLockerProductCustomizationDetailsIds = selectedProducts.map(
      (item) => item.ZnodeMyLockerProductCustomizationDetailsId
    );
    for (const i in data) {
      if (
        znodeMyLockerProductCustomizationDetailsIds?.includes(
          data[i]?.ZnodeMyLockerProductCustomizationDetailsId
        )
      ) {
        const emailData: any = {};

        emailData.ProductId = data[i]?.ProductId;
        emailData.ConfigurationName = data[i]?.ConfigurationName;
        emailData.ProductName = data[i]?.ProductName;
        emailData.SKU = data[i]?.SKU;
        emailData.ConfigurationId = data[i]?.DesignId;
        emailData.ProductCustomizationJson = data[i]?.ProductCustomizationJson;
        emailData.DesignType = data[i]?.DesignType;

        emailProductList.push(emailData);
      }
    }
    setProductListForEmailTemplate(emailProductList);
  };

  const getConfigurationDetailsData = (
    ids: string,
    znodeMyLockerProductCustomizationDetailsIds: number[]
  ) => {
    getConfigurationDetails(ids)
      .then(async (result: any) => {
        getProductDataForEmailTable(result?.data);
        const artifiProductImagesList = [];
        const artifiProductDataList = [];
        const rawlingsProductImagesList = [];
        const rawlingsProductDataList = [];
        for (const r in result?.data) {
          if (
            znodeMyLockerProductCustomizationDetailsIds?.includes(
              result?.data[r]?.ZnodeMyLockerProductCustomizationDetailsId
            )
          ) {
            if (result?.data[r]?.DesignType === "Artifi") {
              const artifiProductImageItem: any = {};

              artifiProductImageItem.designId = result?.data[r]?.DesignId;
              artifiProductImageItem.configurationName = result?.data[r]?.ConfigurationName;
              artifiProductImageItem.img = JSON.parse(
                result?.data[r]?.ProductCustomizationJson
              )?.previewStandardImages;
              artifiProductImagesList.push(artifiProductImageItem);

              const productCustomizationJson = JSON.parse(
                result?.data[r]?.ProductCustomizationJson
              );

              artifiProductDataList.push({
                productName: productCustomizationJson?.productName,
                customAttributes: productCustomizationJson?.customAttributes,
                designType: result?.data[r]?.DesignType,
                designData: productCustomizationJson?.designData,
                designId: productCustomizationJson?.designId,
                designName: productCustomizationJson?.designName,
                sku: productCustomizationJson?.sku,
                configurationName: result?.data[r]?.ConfigurationName,
                pickedStyle: productCustomizationJson?.pickedStyle,
                selectedFabric: productCustomizationJson?.selectedFabric,
                selectedDesignTemplate: productCustomizationJson?.selectedDesignTemplate,
              });
            }
            if (result?.data[r]?.DesignType === "Rawlings") {
              const rawlingsProductImageItem: any = {};

              const aProduct = await associateProduct(
                lockerDetails?.lockerPortalDetails?.PortalId,
                lockerDetails?.lockerPortalDetails?.PublishCatalogId
              );

              const isProduct = aProduct?.data?.PublishProducts.find(
                (item: any) => item.SKU === result?.data[r]?.SKU
              );

              const configurationTypeObject = isProduct?.Attributes?.find(
                (attribute: { AttributeCode: string }) =>
                  attribute.AttributeCode === "ConfigurationType"
              );

              const productCode = configurationTypeObject?.SelectValues[0]?.Code;
              const productCustomizationJson = JSON.parse(
                result?.data[r]?.ProductCustomizationJson
              );
              rawlingsProductImageItem.designId = result?.data[r]?.DesignId;
              rawlingsProductImageItem.configurationName = result?.data[r]?.ConfigurationName;

              if (["RawlingsGlove", "EastonGlove"].includes(productCode)) {
                rawlingsProductImageItem.img = [
                  productCustomizationJson?.previewBack,
                  productCustomizationJson?.previewPalm,
                  productCustomizationJson?.previewWeb,
                ];
              }
              if (productCode === "Helmet" || productCode === "EastonHelmet") {
                rawlingsProductImageItem.img = [productCustomizationJson?.previewFront];
              }
              if (productCode === "WoodBat") {
                rawlingsProductImageItem.img = [
                  productCustomizationJson?.previewFront,
                  productCustomizationJson?.previewKnob,
                  productCustomizationJson?.previewBarrelEnd,
                ];
              }

              rawlingsProductImagesList.push(rawlingsProductImageItem);
              rawlingsProductDataList.push({
                ...result?.data[r],
                ConfiguratorType: productCode,
              });
            }
          }
        }
        setProductImages([
          ...getProductFourImagesOnOnePage(artifiProductImagesList),
          ...getProductFourImagesOnOnePage(rawlingsProductImagesList),
        ]);

        const rawlingsProductDataListNew = rawlingsProductDataList.reduce((acc, current) => {
          if (
            !acc.some(
              (item: any) =>
                item.ZnodeMyLockerProductCustomizationDetailsId ===
                current.ZnodeMyLockerProductCustomizationDetailsId
            )
          ) {
            acc.push(current);
          }
          return acc;
        }, []);

        setProductDetails({
          artifi: getProductDetailsInStructuredManner(artifiProductDataList),
          rawlingsGlove: rawlingsProductDataListNew.filter(
            (item: any) => item.ConfiguratorType === "RawlingsGlove"
          ),
          eastonGloves: rawlingsProductDataListNew.filter(
            (item: any) => item.ConfiguratorType === "EastonGlove"
          ),
          helmet: rawlingsProductDataListNew.filter(
            (item: any) => item.ConfiguratorType === "Helmet"
          ),
          eastonHelmet: rawlingsProductDataListNew.filter(
            (item: any) => item.ConfiguratorType === "EastonHelmet"
          ),
          woodBat: rawlingsProductDataListNew.filter(
            (item: any) => item.ConfiguratorType === "WoodBat"
          ),
        });
      })
      .catch((error: AxiosError) => {
        throw error;
      });
  };

  const getProductServiceList = () => {
    if (lockerDetails?.lockerPortalDetails?.PublishCatalogId) {
      getProductsByDesignId(selectedProducts, userId, lockerDetails?.lockerPortalDetails?.PublishCatalogId)
        .then((res: any) => {
          if (res && res?.data && res?.data?.ProductList.length) {
            const arr1 = res?.data?.ProductList.map((item: any) => item.DesignId);
            const arr2 = Object.values(Object.fromEntries(searchParams));
            const allElementsPresent = arr2.every((element: string) => arr1.includes(element));
            if (allElementsPresent) {
              const znodeMyLockerProductCustomizationDetailsIds = selectedProducts.map(
                (item) => item.ZnodeMyLockerProductCustomizationDetailsId
              );
              getConfigurationDetailsData(
                arr2.join(","),
                znodeMyLockerProductCustomizationDetailsIds
              );
            } else {
              navigate(ROUTES_PATH.HOMEPAGE);
            }
          } else {
            navigate(ROUTES_PATH.HOMEPAGE);
          }
        })
        .catch((error: Error) => {
          throw error;
        });
    }
  };

  useEffect(() => {
    getProductServiceList();
    return () => {
      dispatch(setPlayerRoster({}));
    };
  }, [searchParams, lockerDetails]);

  const pdfLoaded = imgUrl.length === productImages.length;
  return (
    <>
      <div className="page-content-wrapper p-30 share-design-content h-100">
        <Row
          gutter={[
            { xs: 20, sm: 20, md: 24, lg: 30 },
            { xs: 20, sm: 20, md: 24, lg: 30 },
          ]}
          className="global-form-container share-design-2-wrapper"
        >
          <Col span={5} xs={24} md={5} xxl={5} xl={5} className="button-container">
            <BlobProvider
              document={
                <Pdf
                  brandLogo={lockerDetails?.lockerPortalDetails?.WebsiteLogoUrl}
                  productImages={productImages}
                  productDetails={productDetails}
                  billingInformation={playerRoster}
                  playerRoster={playerRoster?.playerRosters}
                />
              }
            >
              {(params: BlobProviderParams) => (
                <>
                  <iframe
                    ref={pdfIframeRef}
                    src={params?.url as string}
                    style={{ display: "none" }}
                  />
                  {!isMobile ? (
                    <Button
                      type="primary"
                      className={
                        params?.loading || loader ? "btn-disabled print-button" : "print-button"
                      }
                      onClick={() => {
                        if (pdfIframeRef.current) {
                          const iframe: any = pdfIframeRef.current;
                          const contentWindow = iframe?.contentWindow;
                          if (contentWindow) {
                            ReactGA.event({
                              category: "print_product_details",
                              action: "print product details button clicked",
                              label: "print product details button clicked"
                            });
                            contentWindow.print();
                          }
                        }
                      }}
                      loading={params?.loading || loader}
                    >
                      {params?.loading || loader ? "Loading..." : "Print"}
                    </Button>
                  ) : (
                    <PDFDownloadLink
                      document={
                        <MobilePdf
                          brandLogo={lockerDetails?.lockerPortalDetails?.WebsiteLogoUrl}
                          productImages={productImages}
                          productDetails={productDetails}
                          billingInformation={playerRoster}
                          playerRoster={playerRoster?.playerRosters}
                          pdfImgUrl={imgUrl}
                          isMobile={true}
                        />
                      }
                      className="pdf-download-button"
                      fileName="Rawlings.pdf"
                    >
                      <Button
                        type="primary"
                        htmlType="submit"
                        className={
                          !pdfLoaded || loader ? "btn-disabled print-button" : "print-button"
                        }
                        loading={!pdfLoaded || loader}
                        data-test-selector={"downloadPdf"}
                      >
                        {!pdfLoaded || loader ? "Loading..." : "Download"}
                      </Button>
                    </PDFDownloadLink>
                  )}
                </>
              )}
            </BlobProvider>
          </Col>
          <Col span={1} xs={24} md={1}>
            <div className="vertical-divider">
              <div className="center-element">
                <span className="orText" data-test-selector="spnOrText">
                  Or
                </span>
              </div>
            </div>
          </Col>
          <Col span={12} xs={24} md={12} xxl={12} xl={12}>
            <Space size={"middle"}>
              <Form
                form={form}
                layout="vertical"
                name="send email"
                initialValues={{ emails: "", myEmail: false }}
                onFinish={onSubmitEmail}
                autoComplete="off"
                className="send-to-email-wrapper"
              >
                <Row gutter={15} className="input-wrapper-container">
                  <Col span={24} xs={24} className="input-label">
                    <Text strong>Send To (email address)</Text>
                  </Col>
                  <Col span={18} xs={14} md={14}>
                    <Form.Item
                      name="emails"
                      rules={[
                        { required: true, message: "Please enter your email address." },
                        () => ({
                          validator(_: RuleObject, value: string) {
                            const regex =
                              /^([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})(,\s*([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}))*$/;

                            if (value && !regex.test(value)) {
                              return Promise.reject(new Error("Invalid email address."));
                            }

                            return Promise.resolve();
                          },
                        }),
                      ]}
                    >
                      <Input className="form-input" data-test-selector={"txtEmailAddress"} />
                    </Form.Item>
                  </Col>
                  <Col span={6} xs={10} md={10}>
                    <Form.Item>
                      <BlobProvider
                        document={
                          <Pdf
                            brandLogo={lockerDetails?.lockerPortalDetails?.WebsiteLogoUrl}
                            productImages={productImages}
                            productDetails={productDetails}
                            billingInformation={playerRoster}
                            playerRoster={playerRoster?.playerRosters}
                          />
                        }
                      >
                        {(params: BlobProviderParams) => {
                          setPdfFile(params?.blob);
                          return (
                            <Button
                              type="primary"
                              htmlType="submit"
                              className={
                                params?.loading || isEmailSending
                                  ? "btn-disabled btn-send-email"
                                  : "btn-send-email"
                              }
                              loading={params?.loading || isEmailSending}
                              data-test-selector={"btnSendEmail"}
                            >
                              {params?.loading ? "Loading..." : "Send Email"}{" "}
                            </Button>
                          );
                        }}
                      </BlobProvider>
                    </Form.Item>
                  </Col>
                  <Col span={24}>
                    <Form.Item name="myEmail" valuePropName="checked" noStyle>
                      <Checkbox>Copy me on the email</Checkbox>
                    </Form.Item>
                  </Col>
                </Row>
              </Form>
            </Space>
          </Col>
          <Col span={1} xs={24} md={1}>
            <div className="vertical-divider">
              <div className="center-element">
                <span className="orText" data-test-selector="spnOrText">
                  Or
                </span>
              </div>
            </div>
          </Col>
          <Col span={5} md={5} xs={24} xxl={5} xl={5} className="button-container">
            <Button
              type="default"
              className="cancel-button"
              onClick={() => navigate(ROUTES_PATH.HOMEPAGE)}
            >
              Cancel
            </Button>
          </Col>
        </Row>
        <Row>
          {!isMobile && (
            <PdfViewer
              brandLogo={lockerDetails?.lockerPortalDetails?.WebsiteLogoUrl}
              productImages={productImages}
              productDetails={productDetails}
              billingInformation={playerRoster}
              playerRoster={playerRoster?.playerRosters}
            />
          )}
        </Row>
      </div>
    </>
  );
};

export default ShareDesign2;
